import { add, startOfDay } from 'date-fns';
import * as yup from 'yup';

import { validateAccountNumberMod11 } from 'Pages/CancelInsurancePage/cancelInsurancePage.helpers';
import { getAppText } from 'Utils/text';
import { CancellationReason, CancelSurveyReason } from './cancelForm.constants';

export const getAutomaticCancellationValidationSchema = (
  isRiskInsurance: boolean,
  cancellingLastInsurance: boolean,
) => {
  if (isRiskInsurance) {
    return yup.object({
      cancelReason: yup
        .string()
        .oneOf(Object.values(CancellationReason))
        .nullable()
        .required(getAppText('cancelInsurance.cancelReason.error.required')),

      bankAccount: cancellingLastInsurance
        ? yup
            .string()
            .nullable()
            .test(
              'isValidAccountNumber',
              'Ugyldig kontonummer',
              validateAccountNumberMod11,
            )
            .required(getAppText('cancelInsurance.bankAccount.error.required'))
        : yup.string().nullable(),

      cancelDate: yup
        .date()
        .required(getAppText('cancelinsurance.cancelDate.error.required'))
        .typeError(getAppText('cancelinsurance.cancelDate.error.format'))
        .min(
          add(startOfDay(new Date()), { days: 1 }),
          getAppText('cancelInsurance.cancelDate.error.minDate'),
        )
        .max(
          add(new Date(), { days: 30 }),
          getAppText('cancelInsurance.cancelDate.error.maxDate'),
        ),
    });
  }

  return yup.object({
    cancelSurvey: yup
      .object({
        reason: yup
          .string()
          .nullable()
          .oneOf(Object.values(CancelSurveyReason))
          .required(
            getAppText('cancelInsurance.cancelSurvey.reason.error.required'),
          ),
        otherReason: yup.string().when('reason', ([reason], schema) => {
          return reason === CancelSurveyReason.OTHER_REASON
            ? schema.required(
                getAppText(
                  'cancelInsurance.cancelSurvey.otherReason.error.required',
                ),
              )
            : schema.notRequired();
        }),
      })
      .nullable()
      .required(),
    cancelDate: yup
      .date()
      .required(getAppText('cancelinsurance.cancelDate.error.required'))
      .typeError(getAppText('cancelinsurance.cancelDate.error.format'))
      .min(
        add(startOfDay(new Date()), { days: 1 }),
        getAppText('cancelInsurance.cancelDate.error.minDate'),
      )
      .max(
        add(new Date(), { days: 30 }),
        getAppText('cancelInsurance.cancelDate.error.maxDate'),
      ),

    bankAccount: cancellingLastInsurance
      ? yup
          .string()
          .nullable()
          .test(
            'isValidAccountNumber',
            'Ugyldig kontonummer',
            validateAccountNumberMod11,
          )
          .required(getAppText('cancelInsurance.bankAccount.error.required'))
      : yup.string().nullable(),
  });
};
